import React from 'react';
import { PeekBox } from '../PeekBox.js';

// Using __webpack_public_path__ to get the correct base path at runtime
// Some applications (ChatGPT widget, for example) are embedded in a different path, so we need to use the correct base path
const getSpinnerPath = () => {
    // @ts-ignore
    if (typeof __webpack_public_path__ !== "undefined") {
        // @ts-ignore
        return __webpack_public_path__ + "images/spinner.gif";
    }
    return "images/spinner.gif";
};
const PeekLoader = ({ height = 50, width = 50, imagePath }) => {
    const defaultPath = getSpinnerPath();
    return (
    //@ts-ignore
    React.createElement(PeekBox, { sx: { height, width }, component: "img", src: imagePath || defaultPath, alt: "Loading..." }));
};

export { PeekLoader, PeekLoader as default };
